import React from "react"
import { Typography } from "@mui/material"

const NotAuth = () => {
    return (
        <Typography variant="h4" sx={{color: 'white'}}>Not Authorization</Typography>
    )
}

export default NotAuth